'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: block;\n  width: 100%;\n  padding-top: 16px;\n  margin-bottom: 24px;\n  border: 0;\n  border-bottom: 1px solid ', ';\n'], ['\n  display: block;\n  width: 100%;\n  padding-top: 16px;\n  margin-bottom: 24px;\n  border: 0;\n  border-bottom: 1px solid ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  border-bottom-color: ', ';\n'], ['\n  border-bottom-color: ', ';\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  ', '\n  ', '\n  ', '\n  ', '\n'], ['\n  ', '\n  ', '\n  ', '\n  ', '\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _helpers = require('../../helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DefaultDivider = _styledComponents2.default.hr(_templateObject, function (props) {
  return props.theme.color.border;
});

DefaultDivider.displayName = 'DefaultDivider';
var Coloured = (0, _styledComponents2.default)(DefaultDivider)(_templateObject2, function (props) {
  return props.theme.color[props.variant];
});

Coloured.displayName = 'Coloured';
var Divider = (0, _styledComponents2.default)(Coloured)(_templateObject3, (0, _helpers.boolStyle)('noTopPad', 'padding-top: 0px;'), (0, _helpers.boolStyle)('noMargin', 'margin: 0px;'), (0, _helpers.boolStyle)('halfWidth', 'width: 50%;'), (0, _helpers.boolStyle)('sidePanel', 'width: 20%;padding-top: 8px;'));

Divider.displayName = 'Divider';
var NitroDivider = function NitroDivider(props) {
  return _react2.default.createElement(Divider, props);
};

NitroDivider.propTypes = {
  className: _propTypes2.default.string
};

exports.default = NitroDivider;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-divider/NitroDivider.js
// module id = 2903
// module chunks = 4